// Jest Snapshot v1, https://goo.gl/fbAQLP

exports[`PricingTier model belongsTo relations 1`] = `
Array [
  "ClientPricing",
]
`;
